export const selectStyles = {
    menuList: (provided: any, state: any) => ({ ...provided, paddingTop: 0, paddingBottom: 0 }),
    menu: (base: any, state: any) => ({ ...base, marginTop: 0 })
}